import React from 'react';
import styled from 'styled-components';
import { SEO } from '../components/SEO';
import { colors, spacing, typography, breakpoints } from '../styles/theme';
import { AnalyticsConsentSettings } from '../components/AnalyticsConsent';

const Page = styled.article`
  max-width: 840px;
  margin: 0 auto;
  padding: ${spacing[8]} ${spacing[4]} ${spacing[16]};
  color: ${colors.text.primary};
  line-height: ${typography.lineHeights.relaxed};

  @media (max-width: ${breakpoints.md}) {
    padding: ${spacing[5]} ${spacing[3]} ${spacing[12]};
  }

  h1 { font-size: ${typography.fontSizes['3xl']}; }
  h2 { margin-top: ${spacing[8]}; font-size: ${typography.fontSizes.xl}; }
  p, li { color: ${colors.text.secondary}; }
`;

export const CookiePolicyPage: React.FC = () => (
  <Page>
    <SEO title="Cookie Policy" description="Cookies and similar analytics technologies used by Event Finder." />
    <h1>Cookie Policy</h1>
    <p>Last updated September 2, 2026.</p>
    <p>Event Finder uses Azure Application Insights for operational reliability and cookieless usage telemetry. With your permission, Application Insights, Google Analytics, and Microsoft Clarity may also use analytics cookies to distinguish sessions, measure product usage, and diagnose interaction problems. Advertising storage remains disabled.</p>
    <h2>Your analytics choice</h2>
    <p>Without analytics consent, Clarity operates in cookieless mode with limited session features, Google Analytics is disabled, and Application Insights cookies are disabled. You can change your choice at any time.</p>
    <AnalyticsConsentSettings />
    <h2>Functional browser storage</h2>
    <p>My Events stores a random identifier in local storage so this browser can return to its remembered events without an account. This is functional storage, not an analytics cookie, and it remains available regardless of your analytics choice. The value is not used for advertising or added to analytics events. Clearing site storage removes this browser&apos;s access to its existing My Events collection and causes a new identifier to be created the next time the feature is used.</p>
    <p>Location permission is managed by your browser. Event Finder does not store your coordinates in a cookie or local storage.</p>
    <h2>Event Groups</h2>
    <p>Creating or viewing an Event Group does not create an Event Finder account. Browser analytics may assign an anonymous session or user identifier. Event Finder does not add a separate stable fingerprint for Event Groups.</p>
    <h2>Browser controls</h2>
    <p>You can also restrict cookies through your browser settings or a content blocker. Some analytics will be unavailable, but public Event Finder workflows remain functional.</p>
  </Page>
);

export default CookiePolicyPage;